import { CellContext } from '@tanstack/react-table'
import { RowAction } from '../types-v4'
import { useSubmitForm } from '../../FormComponent/useSubmitForm'
import { InferFormValues, JsonFormSchemaV2 } from '../../FormComponent/types'
import { DropdownMenuItem } from '@/components/shadcn/dropdown-menu'
import { DynamicIcon } from '@/components/icons/DynamicIcon'
import { useNavigate, useSearchParams } from 'react-router'
import { CATALOG_BASE_PATH } from '@/const'

export function ActionItemNoConfirmation<T, V>({ action, info }: { action: RowAction; info: CellContext<T, V> }) {
  const values = info.row.original
  const handlerId = action.handlerId || ''
  const actionId = action.id || ''
  const emptyTileFilterSelections: Record<string, unknown>[] = []
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { mutate: submitForm } = useSubmitForm(handlerId, emptyTileFilterSelections, actionId)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const meta = info.table.options.meta as any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const isGroup = (info.row.original as Record<string, unknown>).isGroup
  const deleteGroup = meta?.deleteGroup

  const onSelect = (_e: Event) => {
    if (action.type === 'navigate') {
      navigate(`${CATALOG_BASE_PATH}${handlerId}?${searchParams.toString()}`)
      return
    }

    // Special handling for group rows: delete locally if it's a delete action
    // We check if it's a group row and if the action is delete (by id or type)
    // Although strictly speaking we might want to apply this to ANY action on a group row 
    // that isn't edit (which is handled by EditMenuItem), but the requirement was specific to delete.
    // However, for non-confirmation actions, if it IS a delete action, we should use local delete.
    if (isGroup && deleteGroup && (action.id === 'delete' || action.type === 'delete')) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      deleteGroup((info.row.original as any).id)
      return
    }

    submitForm(values as InferFormValues<JsonFormSchemaV2>)
  }

  return (
    <DropdownMenuItem key={action.id} onSelect={onSelect}>
      <div className="flex items-center gap-2">
        <DynamicIcon
          iconName={action.icon || ''}
          lazyLoad={false}
          className="size-3"
          fallback={<div className="size-4" />}
        />
        <span>{action.label}</span>
      </div>
    </DropdownMenuItem>
  )
}
